import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../assets/variables.css";
import "../assets/users.css";
import "../assets/panels.css";
import Loader from "../components/Loader";
import s3Service from "../services/s3Service";
// import '../assets/fonts.css';

const UserShow = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    // Debug environment variables
    console.log("UserShow: Environment variables:", {
      REACT_APP_S3_CDN_NAME: process.env.REACT_APP_S3_CDN_NAME,
      REACT_APP_S3_BUCKET: process.env.REACT_APP_S3_BUCKET,
      REACT_APP_S3_REGION: process.env.REACT_APP_S3_REGION,
      REACT_APP_API_URL: process.env.REACT_APP_API_URL,
    });

    fetch(`${process.env.REACT_APP_API_URL}/api/users/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("UserShow: Received user data:", data);
        console.log("UserShow: User image field:", data.image);
        setUser(data);

        // Process image URL if user has an image
        if (data.image) {
          const processImage = async () => {
            try {
              // Try to get URL from backend first (with CDN support)
              const url = await s3Service.getFileUrlFromBackend(data.image);
              console.log("UserShow: Got image URL from backend:", url);
              setImageUrl(url);
            } catch (err) {
              console.log("UserShow: Backend failed, using local construction");
              // Fallback to local URL construction
              const url = s3Service.getFileUrl(data.image);
              console.log("UserShow: Local URL construction:", url);
              setImageUrl(url);
            }
          };
          processImage();
        }

        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load user");
        setLoading(false);
      });
  }, [id]);

  if (loading) return <Loader />;
  // if (error) return <div>{error}</div>;
  // if (!user) return <div>User not found</div>;

  const yesOrNo = (val) => (val ? "Yes" : "No");
  const isGuardian = user.role === "GUARDIAN" || user.role === "Guardian";
  const userable = user.userable || {};

  return (
    <div className="container">
      {/* Breadcrumb */}

      <div className="breadcrumb-row">
        <span
          className="breadcrumb-main"
          style={{ fontWeight: 400, fontSize: "14px", color: "black", cursor: 'pointer' }}
          onClick={() => navigate('/dashboard')}
        >
          Dashboard
        </span>
        <span
          className="breadcrumb-main"
          style={{ fontWeight: 400, fontSize: "14px", color: "black", cursor: 'pointer' }}
          onClick={() => navigate('/users')}
        >
         / Users
        </span>
        <div
          style={{ background: "#30C693", fontWeight: 400, fontSize: "14px" }}
        >
          <span className="breadcrumb-sep">/</span>
          <span className="breadcrumb-properties">
            {" "}
            {user.name || `${user.first_name || "-"} ${user.last_name || "-"}`}
          </span>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <div className="panel panel-default panel-form" style={{ margin: 0 }}>
            <div className="panel-heading panel-title" style={{ margin: 0 }}>
              <h3 className="mr-auto" style={{ margin: 0 }}>
                Name:{" "}
                {user.name ||
                  `${user.first_name || "-"} ${user.last_name || "-"}`}
              </h3>
              <button
                className="btn btn-edit-user ml-2"
                onClick={() => navigate(`/users/${user.id}/edit`)}
              >
                <i className="glyphicon glyphicon-edit" /> Edit user
              </button>
              {isGuardian && userable?.id && (
                <button
                  className="btn btn-secondary ml-2"
                  style={{ marginLeft: 8 }}
                  onClick={() => navigate(`/guardians/${userable.id}`)}
                >
                  Show guardian page
                </button>
              )}
            </div>
            <div className="panel-body">
              <dl className="dl-horizontal admin-show user-show">
                {/* General Information */}
                <div
                  className="panel-heading panel-title"
                  style={{ fontSize: 16 }}
                >
                  General information
                </div>
                <div
                  className="panel-body"
                  style={{
                    borderRadius: 0,
                    borderColor: "rgba(233, 236, 239, 1)",
                  }}
                >
                  <dl
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      margin: 0,
                    }}
                  >
                    <div style={{ display: "flex", gap: "20px" }}>
                      <dt style={{ flex: 1, textAlign: "right", fontSize: 14 }}>
                        First name:
                      </dt>
                      <dd style={{ flex: 4, fontSize: 12 }}>
                        {user.first_name || "-"}
                      </dd>
                    </div>
                    <div style={{ display: "flex", gap: "20px" }}>
                      <dt style={{ flex: 1, textAlign: "right", fontSize: 14 }}>
                        Last name:
                      </dt>
                      <dd style={{ flex: 4, fontSize: 12 }}>
                        {user.last_name || "-"}
                      </dd>
                    </div>
                    <div style={{ display: "flex", gap: "20px" }}>
                      <dt style={{ flex: 1, textAlign: "right", fontSize: 14 }}>
                        E-mail:
                      </dt>
                      <dd style={{ flex: 4, fontSize: 12 }}>
                        <a href={`mailto:${user.email}`}>{user.email || "-"}</a>
                      </dd>
                    </div>
                  </dl>
                  {user.image && (
                    <div style={{ marginLeft: 24 }}>
                      {imageUrl ? (
                        <img
                          src={imageUrl}
                          className="img-responsive avatar-user"
                          alt="avatar"
                          style={{
                            maxWidth: "200px",
                            maxHeight: "200px",
                            objectFit: "cover",
                          }}
                          onError={(e) => {
                            console.error("Image failed to load:", {
                              originalImage: user.image,
                              constructedUrl: imageUrl,
                              user: user,
                            });
                            e.target.style.display = "none";
                          }}
                          onLoad={(e) => {
                            console.log("Image loaded successfully:", {
                              originalImage: user.image,
                              constructedUrl: imageUrl,
                            });
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: "200px",
                            height: "200px",
                            backgroundColor: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid #ddd",
                          }}
                        >
                          <span style={{ color: "#666" }}>
                            Loading image...
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="clearfix"></div>
                </div>
                {/* Details Information */}
                <div
                  className="panel-heading panel-title"
                  style={{ fontSize: 16 }}
                >
                  Details information
                </div>
                <div
                  className="panel-body"
                  style={{
                    borderRadius: 0,
                    borderColor: "rgba(233, 236, 239, 1)",
                  }}
                >
                  <dl
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      margin: 0,
                    }}
                  >
                    {user.job_title && (
                      <div style={{ display: "flex", gap: "20px" }}>
                        <dt
                          style={{ flex: 1, textAlign: "right", fontSize: 14 }}
                        >
                          Job title:
                        </dt>
                        <dd style={{ flex: 4, fontSize: 12 }}>
                          {user.job_title}
                        </dd>
                      </div>
                    )}
                    {user.phone_number && (
                      <div style={{ display: "flex", gap: "20px" }}>
                        <dt
                          style={{ flex: 1, textAlign: "right", fontSize: 14 }}
                        >
                          Phone number:
                        </dt>
                        <dd style={{ flex: 4, fontSize: 12 }}>
                          {user.phone_number}
                        </dd>
                      </div>
                    )}
                    {user.mobile_number && (
                      <div style={{ display: "flex", gap: "20px" }}>
                        <dt
                          style={{ flex: 1, textAlign: "right", fontSize: 14 }}
                        >
                          Mobile number:
                        </dt>
                        <dd style={{ flex: 4, fontSize: 12 }}>
                          {user.mobile_number}
                        </dd>
                      </div>
                    )}
                    {user.fax_number && (
                      <div style={{ display: "flex", gap: "20px" }}>
                        <dt
                          style={{ flex: 1, textAlign: "right", fontSize: 14 }}
                        >
                          Fax number:
                        </dt>
                        <dd style={{ flex: 4, fontSize: 12 }}>
                          {user.fax_number}
                        </dd>
                      </div>
                    )}
                    {user.address_1 && (
                      <div style={{ display: "flex", gap: "20px" }}>
                        <dt
                          style={{ flex: 1, textAlign: "right", fontSize: 14 }}
                        >
                          Address:
                        </dt>
                        <dd style={{ flex: 4, fontSize: 12 }}>
                          {user.address_1} {user.address_2} {user.address_3}
                        </dd>
                      </div>
                    )}
                    {user.town && (
                      <div style={{ display: "flex", gap: "20px" }}>
                        <dt
                          style={{ flex: 1, textAlign: "right", fontSize: 14 }}
                        >
                          Town:
                        </dt>
                        <dd style={{ flex: 4, fontSize: 12 }}>{user.town}</dd>
                      </div>
                    )}
                    {user.postcode && (
                      <div style={{ display: "flex", gap: "20px" }}>
                        <dt
                          style={{ flex: 1, textAlign: "right", fontSize: 14 }}
                        >
                          Postcode:
                        </dt>
                        <dd style={{ flex: 4, fontSize: 12 }}>
                          {user.postcode}
                        </dd>
                      </div>
                    )}
                    <div style={{ display: "flex", gap: "20px" }}>
                      <dt style={{ flex: 1, textAlign: "right", fontSize: 14 }}>
                        Created at:
                      </dt>
                      <dd style={{ flex: 4, fontSize: 12 }}>
                        {user.created_at || "-"}
                      </dd>
                    </div>
                    <div style={{ display: "flex", gap: "20px" }}>
                      <dt style={{ flex: 1, textAlign: "right", fontSize: 14 }}>
                        Updated at:
                      </dt>
                      <dd style={{ flex: 4, fontSize: 12 }}>
                        {user.updated_at || "-"}
                      </dd>
                    </div>
                  </dl>
                  <div style={{ display: "flex", gap: "20px", marginTop: 16 }}>
                    <div style={{ flex: 1, textAlign: "right", fontSize: 14 }}>
                      <strong>Biography:</strong>
                    </div>
                    <div style={{ flex: 4, fontSize: 12 }}>
                      {user.biography ? (
                        <span
                          dangerouslySetInnerHTML={{ __html: user.biography }}
                        />
                      ) : (
                        <span style={{ color: "#888" }}>No biography</span>
                      )}
                    </div>
                  </div>
                </div>
                {/* Guardian Details */}
                {isGuardian && userable && (
                  <div>
                    <div
                      className="panel-heading panel-title"
                      style={{ fontSize: 16 }}
                    >
                      Guardian details
                    </div>
                    <div
                      className="panel-body"
                      style={{
                        borderRadius: 0,
                        borderColor: "rgba(233, 236, 239, 1)",
                      }}
                    >
                      <dl
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                          margin: 0,
                        }}
                      >
                        {userable.unique_guardian_number && (
                          <div style={{ display: "flex", gap: "20px" }}>
                            <dt
                              style={{
                                flex: 1,
                                textAlign: "right",
                                fontSize: 14,
                              }}
                            >
                              Unique Guardian Number:
                            </dt>
                            <dd style={{ flex: 4, fontSize: 12 }}>
                              {userable.unique_guardian_number}
                            </dd>
                          </div>
                        )}
                        {userable.country && userable.country.nationality && (
                          <div style={{ display: "flex", gap: "20px" }}>
                            <dt
                              style={{
                                flex: 1,
                                textAlign: "right",
                                fontSize: 14,
                              }}
                            >
                              Nationality:
                            </dt>
                            <dd style={{ flex: 4, fontSize: 12 }}>
                              {userable.country.nationality}
                            </dd>
                          </div>
                        )}
                        {userable.religion && userable.religion.name && (
                          <div style={{ display: "flex", gap: "20px" }}>
                            <dt
                              style={{
                                flex: 1,
                                textAlign: "right",
                                fontSize: 14,
                              }}
                            >
                              Religion:
                            </dt>
                            <dd style={{ flex: 4, fontSize: 12 }}>
                              {userable.religion.name}
                            </dd>
                          </div>
                        )}
                        {userable.date_of_birth && (
                          <div style={{ display: "flex", gap: "20px" }}>
                            <dt
                              style={{
                                flex: 1,
                                textAlign: "right",
                                fontSize: 14,
                              }}
                            >
                              Date of birth:
                            </dt>
                            <dd style={{ flex: 4, fontSize: 12 }}>
                              {userable.date_of_birth}
                            </dd>
                          </div>
                        )}
                        {userable.national_insurance_number && (
                          <div style={{ display: "flex", gap: "20px" }}>
                            <dt
                              style={{
                                flex: 1,
                                textAlign: "right",
                                fontSize: 14,
                              }}
                            >
                              National insurance number:
                            </dt>
                            <dd style={{ flex: 4, fontSize: 12 }}>
                              {userable.national_insurance_number}
                            </dd>
                          </div>
                        )}
                        {userable.criminal_record_description && (
                          <div style={{ display: "flex", gap: "20px" }}>
                            <dt
                              style={{
                                flex: 1,
                                textAlign: "right",
                                fontSize: 14,
                              }}
                            >
                              Criminal record description:
                            </dt>
                            <dd style={{ flex: 4, fontSize: 12 }}>
                              {userable.criminal_record_description}
                            </dd>
                          </div>
                        )}
                        {userable.medical_condition_description && (
                          <div style={{ display: "flex", gap: "20px" }}>
                            <dt
                              style={{
                                flex: 1,
                                textAlign: "right",
                                fontSize: 14,
                              }}
                            >
                              Medical condition description:
                            </dt>
                            <dd style={{ flex: 4, fontSize: 12 }}>
                              {userable.medical_condition_description}
                            </dd>
                          </div>
                        )}
                        <div style={{ display: "flex", gap: "20px" }}>
                          <dt
                            style={{
                              flex: 1,
                              textAlign: "right",
                              fontSize: 14,
                            }}
                          >
                            On newsletter list:
                          </dt>
                          <dd style={{ flex: 4, fontSize: 12 }}>
                            {yesOrNo(userable.on_newsletter_list)}
                          </dd>
                        </div>
                        <div style={{ display: "flex", gap: "20px" }}>
                          <dt
                            style={{
                              flex: 1,
                              textAlign: "right",
                              fontSize: 14,
                            }}
                          >
                            On voluntary work:
                          </dt>
                          <dd style={{ flex: 4, fontSize: 12 }}>
                            {yesOrNo(userable.on_voluntary_work_list)}
                          </dd>
                        </div>
                      </dl>
                    </div>
                  </div>
                )}
                {/* Email Preferences (stub) */}
                {isGuardian && (
                  <div>
                    <div
                      className="panel-heading panel-title"
                      style={{ fontSize: 16 }}
                    >
                      Email Preferences
                    </div>
                    <div
                      className="panel-body"
                      style={{
                        padding: 0,
                        borderRadius: 0,
                        borderColor: "rgba(233, 236, 239, 1)",
                      }}
                    >
                      <table style={{ width: '100%', fontSize: '13px', borderCollapse: 'collapse' }}>
                        <tbody>
                          <tr style={{ borderBottom: '1px solid #eee' }}>
                            <td style={{ padding: '8px 12px', color: '#666', fontWeight: '500' }}>
                              I agree that I would like to receive promotional offers, available property lists and other updates from Global Guardians
                            </td>
                            <td style={{ padding: '8px 12px', textAlign: 'right', fontWeight: '600' }}>
                              {user.emails_receive_marketing ? 'Yes' : 'No'}
                            </td>
                          </tr>
                          <tr style={{ borderBottom: '1px solid #eee' }}>
                            <td style={{ padding: '8px 12px', color: '#666', fontWeight: '500' }}>
                              I would like to receive Global Guardians updates by:
                            </td>
                            <td style={{ padding: '8px 12px', textAlign: 'right', fontWeight: '600' }}>
                              {user.emails_updates_by === 1 ? 'Phone' : user.emails_updates_by === 2 ? 'Both' : 'Email'}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ padding: '8px 12px', color: '#666', fontWeight: '500' }}>
                              I agree that Global Guardians can share my contact information with other organisations
                            </td>
                            <td style={{ padding: '8px 12px', textAlign: 'right', fontWeight: '600' }}>
                              {user.emails_share_data_other_organisations ? 'Yes' : 'No'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserShow;
